var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.672,
    height: 26.004,
    viewBox: "0 0 25.672 26.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-4 {\n        fill: none;\n        stroke: #7d7d7d;\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-4 {\n        stroke-linejoin: round;\n      }\n\n      .cls-3 {\n        fill: #7d7d7d;\n      }\n\n      .cls-4 {\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11301",
    "data-name": "Group 11301",
    transform: "translate(-1020.828 -4032.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11299",
    "data-name": "Group 11299",
    transform: "translate(1021 4032.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8062",
    "data-name": "Path 8062",
    className: "cls-1",
    d: "M6.847,104.444c2.3,3.673,5.052,4.594,7.23,4.594a7.98,7.98,0,0,0,1.017-.066",
    transform: "translate(-5.512 -84.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8063",
    "data-name": "Path 8063",
    className: "cls-2",
    d: "M21.473,98.013c.054.117,1.371,2.86,5.805,3.621",
    transform: "translate(-17.285 -78.861)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2207",
    "data-name": "Ellipse 2207",
    className: "cls-3",
    cx: 0.39,
    cy: 0.39,
    r: 0.39,
    transform: "translate(0 17.979)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2208",
    "data-name": "Ellipse 2208",
    className: "cls-3",
    cx: 0.39,
    cy: 0.39,
    r: 0.39,
    transform: "translate(0.39 12.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8064",
    "data-name": "Path 8064",
    className: "cls-1",
    d: "M5.126,30.614c2.153,0,3.19-2.206,3.264-4.392L8.5,23c.249-3.6,3.97-3.714,4.23-3.718,4.414.213,4.593,4.739,4.6,4.943a3.007,3.007,0,0,0,1.517,2.433",
    transform: "translate(-4.126 -15.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8065",
    "data-name": "Path 8065",
    className: "cls-1",
    d: "M18.49,8.163a9.841,9.841,0,0,0-2.567-6.007,7.682,7.682,0,0,0-6.195-2.3c-.017,0-5.809.235-7.5,5.657A12.956,12.956,0,0,0,1.681,8.7v1.744",
    transform: "translate(-1.353 0.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8068",
    "data-name": "Path 8068",
    className: "cls-1",
    d: "M41.054,37.939v0A4.781,4.781,0,0,1,37.562,33.7c-.017-.14-.031-.3-.047-.459a4.031,4.031,0,0,0-.658-2.315,1.924,1.924,0,0,0-1.371-.574,2.145,2.145,0,0,0-1.529.6c-.634.62-.486,1.9-.3,3.053.319,1.948.931,5.66,5.391,7.282",
    transform: "translate(-26.425 -23.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8069",
    "data-name": "Path 8069",
    className: "cls-1",
    d: "M12.54,83.176a5.22,5.22,0,0,0,1.617-.549,5.737,5.737,0,0,0,1.948-1.743,10.129,10.129,0,0,0,6.472,4.669",
    transform: "translate(-10.094 -65.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8070",
    "data-name": "Path 8070",
    className: "cls-3",
    d: "M62.39,114.781V114a.39.39,0,1,0,0,.78Z",
    transform: "translate(-49.906 -91.73)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11300",
    "data-name": "Group 11300",
    transform: "translate(1035.926 4045.213)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1835",
    "data-name": "Ellipse 1835",
    className: "cls-3",
    cx: 0.988,
    cy: 0.988,
    r: 0.988,
    transform: "translate(4.094 10.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7177",
    "data-name": "Path 7177",
    className: "cls-4",
    d: "M3.979,39.876H1.4a.657.657,0,0,1-.7-.594V33.994a.647.647,0,0,1,.7-.594h8.671a.647.647,0,0,1,.7.594v5.288a.647.647,0,0,1-.7.594H7.553",
    transform: "translate(-0.7 -28.25)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10183",
    "data-name": "Group 10183",
    transform: "translate(1.365 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7178",
    "data-name": "Path 7178",
    className: "cls-4",
    d: "M8.7,3.673C8.781,1.655,10.726.7,12.37.7s3.654.7,3.67,2.973",
    transform: "translate(-8.7 -0.7)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1115",
    "data-name": "Line 1115",
    className: "cls-4",
    y2: 2.064,
    transform: "translate(0 2.973)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1116",
    "data-name": "Line 1116",
    className: "cls-4",
    y2: 2.064,
    transform: "translate(7.326 2.973)"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1117",
    "data-name": "Line 1117",
    className: "cls-2",
    y2: 1.439,
    transform: "translate(5.095 8.419)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessControl);
export default __webpack_public_path__ + "static/media/accessControl.54066a0cce87323393bfc3335035f0d6.svg";
export { ForwardRef as ReactComponent };